import React, { useContext, useEffect, useRef } from "react";
import { endpoint } from "../../../../../views/pages/manage/common/constant";
import { UserDetails } from "../../../../../appContext";
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { useWizard } from "../../../../../components/wizard/WizardContext";
import { CourseDetailsPopupById } from "../../../../../views/pages/manage/unAssigned/studentCharges/common";
import { Tooltip } from "@mui/material";
import { IoEyeOutline } from "react-icons/io5";
import { fetchStudentSecurityCourseId } from "../../multiTypeRefund/utils";

//rectification refund reason keys
export const INC_PSID_INC_APPID = "Incorrect PSID or Application Id";
export const OTHERS = "Others";


export const useGetUtils = (setLoading) => {

    const userDetails = useContext(UserDetails);

    const { values, updateValues } = useWizard();
    const { selectedStudent } = values;

    const { psid, applicationId, businessArea } = selectedStudent;
    const { roleId, newPaymentModesRawObject, oldPaymentModesRawObject, rectRefundReasons , 
        // additionalStudentDetails
    } = values?.utils ?? {};

    const fetchRoleId = async () => {
        const details = await fetchAllPromisedData(
            `${endpoint.getUserByEmployeeId}/${userDetails?.employeeId}`,
            true
        );
        if (details && details?.code == 200) {
            const roleId = await details?.data?.userIdProjectRoleDtoList
                .map((item) => {
                    return item?.roleInformationDtoList.map((i) => {
                        return i?.roleId;
                    });
                })
                .flat();
            return roleId;
        }
    };


    const getPaymentModesAndVouchers = async (roleId, processType) => {
        const req = {
            psid,
            applicationId,
            roleId,
            businessArea: businessArea,
            //   opportunityOwnerId,
            examRollNumber: null,
            processType,
        }
        const url = endpoint.paymentCollection.getVouchersAndPaymentMode;
        return fetchAllPostPromisedData(url, req);
    }


    const fetchDetails = async () => {
        const userRoleId = await (roleId || fetchRoleId());
        const newPaymentModesRawObject = await getPaymentModesAndVouchers(userRoleId, "Rectification Refund New"); //used on step 3
        const oldPaymentModesRawObject = await getPaymentModesAndVouchers(userRoleId , "Rectification Refund Old"); //used on step 2 in dropdown

        return {
            roleId: userRoleId,
            newPaymentModesRawObject,
            oldPaymentModesRawObject
        }

    }

    const fetchReasons = async () => {
        const reasons = await dropdownMapping(
            `${endpoint.refund.refundreason}?refundType=RECTIFICATION_REFUND`,
            "reasonDisplayValue",
            "id"
        );

        return { rectRefundReasons: reasons };

    }

    // const fetchAdditionalStudentDetails = async() => {
    //     const securityCourseId = await fetchStudentSecurityCourseId(applicationId);
    //     const additionalStudentDetails = {securityCourseId};

    //     return {additionalStudentDetails};
    // }

    useEffect(() => {
        const fetchUtils = async () => {
            try {
                setLoading(true);

                const utils = await Promise.all([
                    ((roleId && newPaymentModesRawObject && oldPaymentModesRawObject) ? { roleId, newPaymentModesRawObject , oldPaymentModesRawObject } : fetchDetails()),
                    (rectRefundReasons ? { rectRefundReasons } : fetchReasons()),
                    // (additionalStudentDetails ? {additionalStudentDetails} : fetchAdditionalStudentDetails())
                ])

                updateValues("utils", {
                    ...utils[0],
                    ...utils[1],
                    ...utils[2]
                })

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }

        (
            (userDetails && (!roleId || !newPaymentModesRawObject || !oldPaymentModesRawObject)) ||
            !rectRefundReasons
            //  || !additionalStudentDetails
        ) && fetchUtils();

    }, [userDetails]);
}

export const fetchReceiptsByPaymode = async (paymode, selectedStudent, isOthersReasonSelected) => {
    const { applicationId, businessAreaDispVal, psid, courseId } = selectedStudent;

    const url = `${endpoint.refund.rectificationRefund.viewReceiptsByApplicationIdAndPaymentMode}/${applicationId}?businessArea=${businessAreaDispVal}&psid=${psid}&paymode=${paymode?.paymentModeKey?.toUpperCase()}&courseId=${courseId}&isRegularCourse=${!isOthersReasonSelected}`;
    return fetchAllPromisedData(url, true);
}

export const fetchReceiptDetails = async (receiptId, selectedStudent) => {
    const { applicationId, businessAreaDispVal, psid } = selectedStudent;

    const url = `${endpoint.refund.rectificationRefund.viewSingleReceiptDetails}/${applicationId}?businessArea=${businessAreaDispVal}&psid=${psid}&receiptId=${receiptId}`;
    return fetchAllPromisedData(url);
}

export const studentDetailsLabelFieldMapping = (selectedStudent, dropdowns) => {

    const { courseId, businessArea } = selectedStudent;
    const buDesc = dropdowns?.businessAres?.find(bu => bu?.value === businessArea)?.businessAreaDesc;

    return [
        { label: 'PSID', field: 'psid' },
        { label: 'Student Name', field: 'studentName' },
        { label: 'Application No', field: 'applicationId' },
        // {label : 'Parent Name', field : 'parentName'},
        {
            label: 'Course ID',
            field: 'courseId',
            renderExtra: (
                <CourseDetailsPopupById courseId={courseId} placement="left-end" cta={<IoEyeOutline className='ml-2' />} />
            )
        },
        { label: 'Term', field: 'termDispVal' },
        { label: 'Career', field: 'academicCareerValue' },
        { label: 'Stream', field: 'academicGroupDispValue' },
        {
            label: 'Branch',
            field: 'businessAreaDispVal',
            renderExtra: (
                <Tooltip title={buDesc}>
                    <span className='ml-2'><IoEyeOutline /></span>
                </Tooltip>
            )
        },
    ]
}

export const useSaveDataToConfigValues = (data, key) => {
    const latestDataRef = useRef({});
    const { setValues } = useWizard();

    latestDataRef.current = data;

    useEffect(() => {
        return () => {
            setValues(prev => ({
                ...prev,
                [key] : {
                    ...(prev?.[key] ?? {}),
                    ...latestDataRef.current
                }
            }))
        }
    }, [])

}